const initialState = {
  data: {
    displayName: null,
    email: null,
    uid: null,
    userLanguages: {
      base: '',
      learning: '',
    },
    appLanguage: null,
    role: null,
  },
  isAuthenticated: false,
};

export default {
  namespaced: true,
  state: {
    ...initialState,
  },

  getters: {
    userData (state) {
      return state.data;
    },
    userIsAuthenticated(state) {
      return state.isAuthenticated;
    },
    userUid (state) {
      return state.data.uid;
    },
    userLanguages (state) {
      return state.data.userLanguages;
    },
    hasUserLanguages (state) {
      return Object.keys(state.data.userLanguages).every((lang) => state.data.userLanguages[lang].length > 0);
    },
    appLanguage (state) {
      return state.data.appLanguage;
    },
  },

  actions: {
    setUserData ({ dispatch }, userData) {
      dispatch('setUSER_DATA', userData);
    },

    setUserLanguages ({ dispatch }, userLanguages) {
      dispatch('setUSER_LANGUAGES', userLanguages);
    },

    setAppLanguage ({ dispatch }, appLanguage) {
      dispatch('setAPP_LANGUAGE', appLanguage);
    },

    setLogin ({ dispatch }, user) {
      const userData = {
        displayName: user.displayName,
        email: user.email,
        uid: user.uid,
      };

      dispatch('setUSER_DATA', userData);
      dispatch('setUSER_AUTH', true);
    },

    setLogout ({ dispatch }, user) {
      dispatch('setUSER_DATA', initialState.user);
      window.localStorage.removeItem('languageNerd');
      if (window.location.pathname !== '/') {
        user.$router.push('/');
      }
      window.location.reload();
    },

    setUSER_DATA ({ commit }, userData) {
      commit('setUSER_DATA', userData);
    },
    setUSER_AUTH ({ commit }, authStatus) {
      commit('setUSER_AUTH', authStatus);
    },
    setUSER_LANGUAGES({ commit }, userLanguages) {
      commit('setUSER_LANGUAGES', userLanguages);
    },
    setAPP_LANGUAGE({ commit }, appLanguage) {
      commit('setAPP_LANGUAGE', appLanguage);
    },
  },

  mutations: {
    setUSER_DATA(state, userData) {
      state.data = {
        ...state.data,
        ...userData,
      };
    },
    setUSER_AUTH(state, authStatus) {
      state.isAuthenticated = authStatus;
    },
    setUSER_LANGUAGES(state, userLanguages) {
      state.data.userLanguages = {
        ...state.data.userLanguages,
        ...userLanguages,
      };
    },
    setAPP_LANGUAGE(state, appLanguage) {
      state.data.appLanguage = appLanguage;
    },
  },
};
